import React, { useEffect } from 'react'
import MainTab from './MainTab'

export default function Settings() {
  // const navigate=useNavigate()
  // useEffect(()=>{
  //   navigate('/settings/eventStatus/');
  // },[])
    return (
        <div>
          <MainTab/>
        </div>
    )
}
